export const harshEventFieldConfig = [
  {
    name: "harshEventType",
    label: "Harsh Event Type",
    type: "select",
    options: [
      { value: "Hard Brake", label: "Hard Brake" },
      { value: "Hard Acceleration", label: "Hard Acceleration" },
      { value: "Harsh Cornering", label: "Harsh Cornering" },
      { value: "Collision Warning", label: "Collision Warning" },
      { value: "Speeding -6-10", label: "Speeding -6-10" },
      { value: "Speeding 10 over", label: "Speeding 10 over" },
    ],
    validation: { required: "Harsh event type is required" },
  },
  {
    name: "date",
    label: "Date",
    type: "date",
    validation: { required: "Date is required" },
  },
  {
    name: "driverId",
    label: "Driver",
    type: "combo",
    dataKey: "drivers",
    validation: { required: "Driver is required" },
  },
  {
    name: "truckId",
    label: "Truck",
    type: "combo",
    dataKey: "trucks",
    validation: { required: "Truck is required" },
  },
  {
    name: "status",
    label: "Status",
    type: "select",
    options: [
      { value: "Pending", label: "Pending" },
      { value: "Completed", label: "Completed" },
      { value: "NoAnswer", label: "No Answer" },
    ],
    validation: { required: "Status is required" },
  },
  {
    name: "addedBy",
    label: "Added By",
    type: "text",
    validation: { required: "Added by is required" },
  },
];

export const harshEventInitialValues = {
  harshEventType: "",
  date: "",
  driverId: null,
  truckId: null,
  status: "",
  addedBy: "",
};
